import React from 'react'
// import ReactDOM from 'react-dom/client'
import ReactDOM from 'react-dom'
import './assets/styles'

import { App } from './components'

// 리액트 버전 18 -> 17로 다운그레이드 createRoot를 사용할 수 없게됨
// const root = ReactDOM.createRoot(document.getElementById('root'))

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
)
